import Check from '@/assets/icons/check.svg?react';
import XClose from '@/assets/icons/x-close.svg?react';
import Dot from '@/assets/icons/dot.svg?react';
import type { ParseKeys } from 'i18next';
import type { SurveyChipVariant } from './survey-status.types';

// The variant is the API value (`didn't sent` included); the label is looked up at render time.
export const surveyStatusLabelKey = {
  sent: 'status.sent',
  "didn't sent": 'status.notSent',
  received: 'status.received',
} as const satisfies Record<SurveyChipVariant, ParseKeys<'surveys'>>;

export const surveyStatusIcon = {
  sent: Check,
  "didn't sent": XClose,
  received: Dot,
};
